import { Component } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    TranslateService
  ]
})
export class AppComponent {
  title = 'Freelock';
  lan:string = "es";
  textodes:string = "";

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  constructor(
    private translate: TranslateService,
  ){
    this.translate.use('es');
    this.translate.get('QUINTO.sub1').subscribe(res => { this.textodes = res;});

    setTimeout(() => {
      this.textodes = this.traducciones(this.textodes);
    }, 500);


    this.galleryOptions = [
      {
          width: '800px',
          height: '500px',
          thumbnailsColumns: 4,
          imageAnimation: NgxGalleryAnimation.Slide
      },
      // max-width 800
      {
          breakpoint: 800,
          width: '100%',
          height: '600px',
          imagePercent: 80,
          thumbnailsPercent: 20,
          thumbnailsMargin: 20,
          thumbnailMargin: 20
      },
      // max-width 400
      {
          breakpoint: 400,
          preview: false
      }
    ];

    this.galleryImages = [
      {
          small: 'assets/img/img1.jpg',
          medium: 'assets/img/img1.jpg',
          big: 'assets/img/img1.jpg'
      },
      {
        small: 'assets/img/img3.jpg',
        medium: 'assets/img/img3.jpg',
        big: 'assets/img/img3.jpg'
      },
      {
        small: 'assets/img/img2.jpg',
        medium: 'assets/img/img2.jpg',
        big: 'assets/img/img2.jpg'
      }
    ];
  }

  selLan(val){
    this.lan = val;
    this.translate.use(val);
    this.translate.get('QUINTO.sub1').subscribe(res => { this.textodes = res;});
    setTimeout(() => {
      this.textodes = this.traducciones(this.textodes);
    }, 500);
  }

  traducciones(res){
    var texto:string = "";
    for(let x=0; x < res.length; x++){
      var text = res[x];
      text = text.toString().replace("xx", "");
      text = text.toString().replace("xx,", "");
       texto += text;
    }

    return texto;
}


}





// WEBPACK FOOTER //
// ./src/app/app.component.ts